import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import { ValueAccessor } from '../../value-accessor/value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'sera-toggle-button',
    templateUrl: './sera-toggle-button.component.html',
    styleUrls: ['./sera-toggle-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraToggleButtonComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SeraToggleButtonComponent extends ValueAccessor<boolean> {
    @Input()
    onLabel!: string;

    @Input()
    offLabel!: string;

    @Input()
    onIcon!: string;

    @Input()
    offIcon!: string;

    @Input()
    iconPos: 'left' | 'right' = 'left';

    @Input()
    disabled: boolean = false;

    @Input()
    unToggleable: boolean = false;

    @Input()
    toggleButtonStyleClass: string = '';

    @Output() stateChanged = new EventEmitter<boolean>();

    constructor(injector: Injector) {
        super(injector);
    }
}
